import Page from "./Page";
import { AMSTERDAM, NEW_YORK, SAN_JOSE, SINGAPORE } from "./Constants";
import { geoPath } from "d3-geo";
import { geoKavrayskiy7 } from "d3-geo-projection";
import { feature } from "topojson-client";
import world from "./ne_110m_land.json";
import "./Datacenters.css";


export const DATACENTER  = "Datacenter";
export const DATACENTERS = "Datacenters";


export default class Datacenters extends Page {
   constructor( props, context ) {
      super( props, context );

      this.state = {
         data: feature( world, world.objects.ne_110m_land ).features,
         cities: [
            { id: NEW_YORK,  coordinates: [ -74.0059, 40.7128] },
            { id: SAN_JOSE,  coordinates: [-121.8863, 37.3382] },
            { id: SINGAPORE, coordinates: [ 103.8198,  1.3521] },
            //{ id: "Paris",     coordinates: [   2.3522, 48.8566] },
            { id: AMSTERDAM, coordinates: [   4.8952, 52.3702] },
         ],
         width: 320,
         height: 320,
      };

      this.onResize = this.onResize.bind( this );
   }


   projection() {
      const scale = this.state.width >= this.state.height ? 100 : 100 * this.state.width / this.state.height;

      return geoKavrayskiy7().scale( scale ).translate( [ this.state.width / 2, this.state.height / 2 ] );
   }


   onCityClick( i ) {
      this.context.router.push( `/${DATACENTER}/${this.state.cities[i].id}` );
   }


   onResize() {
      const header = document.querySelector( "header" ).getBoundingClientRect(); // HARD-CODED in conjunction with App.js
      const footer = document.querySelector( "footer" ).getBoundingClientRect(); // HARD-CODED in conjunction with App.js

      this.setState( { width: header.width, height: window.innerHeight - header.height - footer.height } );
   }


   componentDidMount() {
      super.componentDidMount();

      this.onResize();

      window.addEventListener( "resize", this.onResize );
   }


   componentWillUnmount() {
      window.removeEventListener( "resize", this.onResize );
   }


   render() {
      const style = { width:this.state.width, height:this.state.height }; // required to avoid a scroll bar for some reason

      return (
         <div className="Datacenters" style={style}>
            <div className="Datacenters-details">
               Click/Tap a dot to see a datacenter's details.
            </div>

            <svg width={this.state.width} height={this.state.height} viewBox={`0 0 ${this.state.width} ${this.state.height}`}>
               <g className="countries">
                  {
                     this.state.data.map( ( d, i ) => (
                        <path
                           key={`path-${i}`}
                           d={geoPath().projection( this.projection() )( d )}
                           stroke="#FFFFFF"
                           strokeWidth={0.5}
                        />
                     ) )
                  }
               </g>
               <g className="markers">
                  {
                     this.state.cities.map( ( city, i ) => (
                        <circle
                           key={`marker-${i}`}
                           cx={this.projection()( city.coordinates )[0]}
                           cy={this.projection()( city.coordinates )[1]}
                           r={8}
                           fill="#FFFF00"
                           stroke="#FFFF00"
                           className="datacenter"
                           onClick={() => this.onCityClick( i )}
                        />
                     ) )
                  }
               </g>
            </svg>
         </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/Datacenters.js